import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Announcement from '../../../classes/announcement/announcement';

import { Header } from '../../../ui/Table';

import { COLUMN_TYPES as CT } from '../../../consts';

class TableView extends Component {
  constructor (props) {
    super(props);

    this.state = {
      selectedRow: null,
      dataHash: null
    };

    this.dictionary = this.props.dictionary;

    this.getRealtyRow = this.getRealtyRow.bind(this);
    this.selectRow = this.selectRow.bind(this);
  }

  getHeaderList () {
    return this.props.tableFactory.getHeaders() || [];
  }

  getColumnList () {
    return this.props.tableFactory.getColumns() || [];
  }

  static getDerivedStateFromProps (props, state) {
    const dataHash = (props.data && props.data.hashCode()) || null;

    if (dataHash !== state.dataHash) {
      return {
        selectedRow: null,
        dataHash
      };
    }

    return null;
  }

  selectRow (selectedRow) {
    const that = this;
    return function () {
      that.setState({
        selectedRow
      });
    };
  }

  /**
   * Создает ячейку
   * @param cellType
   * @param data
   * @returns {*}
   */
  makeCell (cellType, data, rawData) {
    const {
      cellFactory,
      eventAddFavorites,
      eventRemoveFavorites,
      eventOpenCommentForm,
      eventOpenClaimForm,
      eventMapModal,
      eventShowContacts,
      eventClickAnnouncement
    } = this.props;

    const key = cellType + data.getProperty().getId();

    switch (cellType) {
      case CT.realtyType:
        return cellFactory.makeRealtyType(key, data);
      case CT.description:
        return cellFactory.makeDescription(key, data, eventAddFavorites, eventRemoveFavorites, eventOpenCommentForm, eventOpenClaimForm, eventMapModal);
      case CT.descriptionAndType:
        return cellFactory.makeDescriptionAndType(key, data, eventAddFavorites, eventRemoveFavorites, eventOpenCommentForm, eventOpenClaimForm, eventMapModal);
      case CT.price:
        return cellFactory.makePrice(key, data);
      case CT.priceAndPay:
        return cellFactory.makePriceAndPay(key, data);
      case CT.priceAndPricePerMeter:
        return cellFactory.makePriceAndPricePerMeter(key, data);
      case CT.pricePerMeter:
        return cellFactory.makePricePerMeter(key, data);
      case CT.priceTotal:
        return cellFactory.makePriceTotal(key, data);
      case CT.area:
        return cellFactory.makeArea(key, data);
      case CT.building:
        return cellFactory.makeBuilding(key, data);
      case CT.contacts:
        return cellFactory.makeContacts(key, data, this.props.onUpdateFilter, eventShowContacts, rawData);
      case CT.moreProperty:
        return cellFactory.makeMoreProperty(key, data);
      case CT.date:
        return cellFactory.makeDate(key, data);
      case CT.land:
        return cellFactory.makeLand(key, data);
      case CT.address:
        return cellFactory.makeAddress(key, data, eventClickAnnouncement, rawData);
      case CT.photos:
        return cellFactory.makePhotos(key, data, eventClickAnnouncement, rawData);
      case CT.material:
        return cellFactory.makeMaterial(key, data);
      case CT.seller:
        return cellFactory.makeSeller(key, data, this.props.onUpdateFilter);
      case CT.floor:
        return cellFactory.makeFloor(key, data);
      case CT.buildingSize:
        return cellFactory.makeBuildingSize(key, data);
      case CT.dealCondition:
        return cellFactory.makeDealCondition(key, data);

      default:
        return cellFactory.makeEmpty(key);
    }
  }

  /**
   * Строка с объявлением
   * @param item
   * @returns {*}
   */
  getRealtyRow (item) {
    const data = new Announcement(item, this.dictionary);
    const rawData = item;
    const id = data.getId();
    const selected = id === this.state.selectedRow ? ' selected' : '';
    const services = data.getServices().map(v => v.alias).join(' ');

    return (
      <tr key={id} className={services + selected} onClick={this.selectRow(id)}>
        {this.getColumnList().map(cellType => this.makeCell(cellType, data, rawData))}
      </tr>
    );
  }

  getRealtyList () {
    return this.props.data.map(this.getRealtyRow);
  }

  render () {
    const { sortKey, onSort, isLoading, disableSortHeader, className, isBordered } = this.props;
    const tableClass = [
      'table',
      (isBordered ? 'table-bordered' : null),
      'grid-view',
      className
    ].filter(Boolean);

    return (
      <div style={{position: 'relative'}}>
        { isLoading &&
        (
          <div className='ajax-waiting-overlay'>
            <div className='radial-progress'>
              <div className='circle'>
                <div className='fill' />
              </div>
            </div>
          </div>
        )
        }

        <table className={tableClass.join(' ')}>
          <thead>
            <Header
              sortKey={sortKey}
              onSort={onSort}
              headerList={this.getHeaderList()}
              disableSortHeader={disableSortHeader}
            />
          </thead>
          <tbody>
            { this.getRealtyList() }
          </tbody>
        </table>
      </div>
    );
  }
}

TableView.propTypes = {
  domain: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,

  tableFactory: PropTypes.object.isRequired,
  cellFactory: PropTypes.object.isRequired,
  onSort: PropTypes.func.isRequired,
  sortKey: PropTypes.string,
  disableSortHeader: PropTypes.bool,

  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,

  dictionary: PropTypes.object.isRequired,
  onUpdateFilter: PropTypes.func,

  className: PropTypes.string,
  isBordered: PropTypes.bool,

  eventAddFavorites: PropTypes.func,
  eventRemoveFavorites: PropTypes.func,
  eventOpenCommentForm: PropTypes.func,
  eventOpenClaimForm: PropTypes.func,
  eventMapModal: PropTypes.func,
  eventShowContacts: PropTypes.func,
  eventClickAnnouncement: PropTypes.func
};

TableView.defaultProps = {
  onUpdateFilter: () => null,
  sortKey: null,
  disableSortHeader: false,
  className: '',
  isBordered: true,

  eventAddFavorites: id => {},
  eventRemoveFavorites: id => {},
  eventOpenCommentForm: id => {},
  eventOpenClaimForm: id => {},
  eventMapModal: id => {},
  eventShowContacts: id => {},
  eventClickAnnouncement: id => {}
};

export default TableView;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/TableView.jsx